
(function () {
    function startCountdown(el) {
        const targetDate = el.dataset.date;
        const expiredText = el.dataset.text || '';

        // Parse date safely
        const targetTime = Date.parse(targetDate);
        if (Number.isNaN(targetTime)) {
            console.warn('Countdown: invalid date on element', el, targetDate);
            // You might display a fallback
            const expired = el.querySelector('.countdown__expired');
            if (expired) {
                expired.textContent = 'Invalid date';
                expired.hidden = false;
            }
            return;
        }

        // Cache span references within this element
        const daysEl = el.querySelector('.countdown__days');
        const hoursEl = el.querySelector('.countdown__hours');
        const minsEl = el.querySelector('.countdown__minutes');
        const secsEl = el.querySelector('.countdown__seconds');
        const expiredEl = el.querySelector('.countdown__expired');

        function update() {
            const now = Date.now();
            const diff = targetTime - now;

            if (diff <= 0) {
                clearInterval(timer);
                if (expiredEl) {
                    expiredEl.textContent = expiredText;
                    expiredEl.hidden = false;
                } else {
                    // Graceful fallback: replace list with text
                    el.innerHTML = `<span>${expiredText}</span>`;
                }
                return;
            }

            const days = Math.floor(diff / 86400000); // 1000*60*60*24
            const hours = Math.floor((diff % 86400000) / 3600000);
            const minutes = Math.floor((diff % 3600000) / 60000);
            const seconds = Math.floor((diff % 60000) / 1000);

            if (daysEl) daysEl.textContent = Number(days);
            if (hoursEl) hoursEl.textContent = Number(hours);
            if (minsEl) minsEl.textContent = Number(minutes);
            if (secsEl) secsEl.textContent = Number(seconds);
        }

        // Prime immediately so it doesn't start blank
        update();
        const timer = setInterval(update, 1000);
    }

    // Initialise after DOM is ready
    function initCountdowns() {
        document.querySelectorAll('.countdown[data-date]').forEach(startCountdown);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCountdowns);
    } else {
        initCountdowns();
    }
})();
